import { render, staticRenderFns } from "./DialogResourceSubDayOff.vue?vue&type=template&id=e3823ecc&"
import script from "./DialogResourceSubDayOff.vue?vue&type=script&lang=js&"
export * from "./DialogResourceSubDayOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports